import { render, staticRenderFns } from "./PwaInstallHome.vue?vue&type=template&id=4e89e0f3&scoped=true&"
import script from "./PwaInstallHome.vue?vue&type=script&lang=js&"
export * from "./PwaInstallHome.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallHome.vue?vue&type=style&index=0&id=4e89e0f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e89e0f3",
  null
  
)

export default component.exports